module.exports = __webpack_public_path__ + "3efef27088b8fd4c29afcc9c5bdc22a2.MP3";